/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Account_Exists_DifferentInputs */



/**
* | output |
* | --- |
* | "An account with this email already exists. Please sign in with email/password instead." |
*
* @param {Login_Error_Account_Exists_DifferentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_account_exists_different = /** @type {((inputs?: Login_Error_Account_Exists_DifferentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Account_Exists_DifferentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un compte avec cet email existe déjà. Veuillez vous connecter avec email/mot de passe à la place.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für diese E-Mail-Adresse existiert bereits ein Konto. Bitte melden Sie sich stattdessen mit E-Mail-Adresse und Passwort an.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esiste già un account con questo indirizzo email. Accedi con indirizzo email/password.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Учетная запись с этим адресом электронной почты уже существует. Пожалуйста, войдите, используя вместо этого адрес электронной почты и пароль.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ya existe una cuenta con este correo electrónico. Inicia sesión con tu correo electrónico y contraseña.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此邮箱已注册账号。请使用邮箱/密码登录。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このメールアドレスのアカウントは既に存在します。代わりにメールアドレスとパスワードでサインインしてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस ईमेल पते से पहले से ही एक खाता मौजूद है। कृपया इसके बजाय ईमेल/पासवर्ड से साइन इन करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Já existe uma conta com este endereço de e-mail. Por favor, faça login com seu e-mail e senha.")
	return /** @type {LocalizedString} */ ("An account with this email already exists. Please sign in with email/password instead.")
});